<app-loading *ngIf="isLoading"></app-loading>
<div class="card list-view card-list-bg mb-5" [class.full-height]="!isEnabled" *ngIf="!isLoading" >
  <form [formGroup]="billingConfigForm">
    <div
      class="card-header list-header d-flex justify-content-between align-items-center py-3 px-4 text-white rounded list">
      <h5 class="mb-0 font-weight-bold">
        {{ ('Invoicing (' + merDba + ')') | translate }}
      </h5>
      <div class="d-flex align-items-center">
        <div *ngIf="!editBilling" class="font-weight-bold text-white d-flex align-items-center mr-3">
          <h5 class="fw-bold mb-0 mr-1">View Only</h5>
          <i data-feather="help-circle" appFeatherIcon class="icon-sm"></i>
        </div>
        <ui-switch [disabled]="isAddMerchant" color="#64bd63" defaultBgColor="#b6b2b2" checkedLabel="Enabled"
          uncheckedLabel="Disabled" size="medium" formControlName="isEnabledControl" (change)="onChangeToggule($event)"
          [disabled]="disable && !editBilling">
        </ui-switch>
      </div>
    </div>
  </form>
  <aw-wizard *ngIf="isEnabled" id="mb-wizard" #wizard [disableNavigationBar]='true' [navBarLocation]="'top'"
    [awNavigationMode] navigateBackward="deny" class="py-4">
    <aw-wizard-step stepId="0" stepTitle="Sell Rate">
      <app-merchant-contract [merchantId] = "merchantId" (contractForm)="contractFormFn($event)"
        (contractLoaderFn)="contractFormLoaderFn($event)" [disable]="!editBilling"></app-merchant-contract>

      <div class="fixed-bar">
        <div class="d-flex justify-content-end mt-2 pb-3 px-5">
          <button type="submit" class="btn btn-outline-primary btn-sm mt-3 mr-3" awPreviousStep (click)="goBack()">
            {{'Back' | translate}} </button>
          <button type="submit" class="btn btn-primary btn-sm mt-3" awNextStep [disabled]="!conractForm || conractForm?.invalid">
            {{'htmlText.next' | translate}}
          </button>
        </div>
      </div>
    </aw-wizard-step>
    <aw-wizard-step stepId="1" stepTitle="Delivery Method & Contact Info">

      <form [formGroup]="deliveryForm" >
        <p-fieldset class="p-0 m-0" legend="Delivery" [toggleable]="false" [collapsed]="false">
          <div class="row">
            <div class="col-12 col-md-4">
              <ng-select class="w-100" [items]="paymentType" bindValue="value" bindLabel="key" [clearable]="false" 
                [multiple]="false" formControlName="paymentMethod" [searchable]="false" (change)="onOptionClicked($event)">
                <ng-template ng-label-tmp let-item="item">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <span *ngIf="achLoader && item.value === 'BANK'" class="spinner-border spinner-border-sm mr-2"        role="status" aria-hidden="true">
                    </span>
                    <span>{{ item.key }}</span>
                  </div>
                </ng-template>
              
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <span>{{ item.key }}</span>
                    <!-- <span *ngIf="achLoader && item.value === 'BANK'" class="spinner-border spinner-border-sm ml-2"   role="status" aria-hidden="true"></span> -->
                    <!-- <span class="ml-2" aria-hidden="true"> <i data-feather="check-circle" appFeatherIcon class="icon-sm mr-2"></i></span> -->
                  </div>
                </ng-template>
              </ng-select>
              <div *ngIf="deliveryForm.get('paymentMethod')?.touched && deliveryForm.get('paymentMethod')?.errors"
                class="error text-danger mt-1">
                <div *ngIf="deliveryForm.get('paymentMethod')?.errors['required']">
                  {{ 'Payment Method is required' | translate }}
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>

      <p-fieldset class="p-0 m-0" legend="Contact Information" [toggleable]="false" [collapsed]="false">
        <div class="row">
          <div class="col-md-4">
            <label class="control-label font-weight-bold">{{ 'Email' | translate }}</label>
            <input type="email" formControlName="email" class="form-control" required [ngClass]="{
                'is-invalid':
                  (deliveryForm.get('email')?.touched || deliveryForm.get('email')?.dirty) &&
                  deliveryForm.get('email')?.invalid || deliveryForm.get('email')?.invalid 
              }" />
            <div *ngIf="deliveryForm.get('email')?.invalid" class="error text-danger mt-1">
              <div *ngIf="deliveryForm.get('email')?.errors?.['required']">
                {{ 'Email is required' | translate }}
              </div>
              <div *ngIf="deliveryForm.get('email')?.errors?.['email']">
                {{ 'Invalid Email' | translate }}
              </div>
            </div>

          </div>
      
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label font-weight-bold">{{ 'Phone' | translate }}</label>
              <br />
              <div [ngClass]="{
                  'is-invalid':
                    (deliveryForm.get('phone')?.touched || deliveryForm.get('phone')?.dirty) &&
                    deliveryForm.get('phone')?.invalid
                }">
                <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                  [selectedCountryISO]="CountryISO.UnitedStates" [maxLength]="maxLen" [phoneValidation]="true"
                  [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National" formControlName="phone"[selectedCountryISO]="selectedPhoneCountryCode">
                </ngx-intl-tel-input>
              </div>
      
              <div
                *ngIf="(deliveryForm.get('phone')?.touched || deliveryForm.get('phone')?.dirty) && deliveryForm.get('phone')?.invalid"
                class="error text-danger mt-1">
                <div *ngIf="deliveryForm.get('phone')?.errors?.['required']">
                  {{ 'Phone number is required' | translate }}
                </div>
                <div *ngIf="deliveryForm.get('phone')?.errors?.['validatePhoneNumber']">
                  {{ 'Invalid Phone Number' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <div class="row">
          <p-messages severity="warn" id="p-message-css">
            <ng-template pTemplate>
              <p class="font-weight-bold">NOTE:</p>
              <p>The invoice and payment link (if selected as the delivery method) will be sent to this contact.</p>
            </ng-template>
          </p-messages>
        </div>
      </p-fieldset>
      </form>

      <div class="fixed-bar">
        <div class="d-flex align-items-center justify-content-end mt-2 pb-3 px-5">
          <button type="button" class="btn btn-outline-primary btn-sm mt-3 mr-3" awPreviousStep>
            {{ 'Back' | translate }}
          </button>
          <button type="submit" class="btn btn-primary btn-sm mt-3" (click)="savePaymentDetails()"
            [disabled]="deliveryForm.invalid || submitLoader || !editBilling">
            <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            {{ 'htmlText.finish' | translate }}
          </button>
        </div>
      </div>

    </aw-wizard-step>

  </aw-wizard>

  <div *ngIf="disable && !isEnabled" class="d-flex align-items-center justify-content-center my-5 pt-5">
    <ng-container>
      <p-messages severity="warn" id="p-message-css-1">
        <ng-template pTemplate>
          <p class ="p-1">Please Enable Billing to Proceed further</p>
        </ng-template>
      </p-messages>
    </ng-container>
  </div>
</div>


<ng-template class="file-confirmation-width" #payaConfirmation let-modal>
  <form [formGroup]="payaModelForm" (ngSubmit)="onPayaModelSubmit()">
  <div class="modal-header">
    <h5 class="text-uppercase">{{ 'htmlText.payaConfirmModalHeader' | translate }}</h5>
  </div>
  <div class="modal-body">
    <div class="pb-2 payaModal">{{'htmlText.payaMessageContent' | translate}}</div>
    <div class="display-align ml-5">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="payaYes"  name="selectedOption" value="1" formControlName="selectedOption" (change)="payaConfirmWithYes()" [attr.disabled]=" payaOptionDisable.optionOneDisable ? '' : null " />
        <span class="form-check-label ml-0 payaModal" for="payaYes">{{ 'htmlText.payaYesContent' | translate }}</span>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" id="payaNo"  name="selectedOption" value="2" formControlName="selectedOption" [attr.disabled]=" payaOptionDisable.optionTwoDisable ? '' : null "/>
        <span class="form-check-label ml-0 payaModal" for="payaNo">{{ 'htmlText.payaNoContent' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer text-right">
    <button type="button" (click)="modal.close(); onFormCancelled();" class="text-right btn btn-danger mr-2" [disabled]="ppdOrCcdValidationLoading">{{ 'htmlText.cancel' | translate }}</button>
    <button type="submit" class="text-right btn btn-primary" [disabled]="!payaModelForm.valid || ppdOrCcdValidationLoading"><span *ngIf="ppdOrCcdValidationLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span> {{ 'htmlText.proceed' | translate }} </button>
  </div>
</form>
</ng-template>

<ng-template class="file-confirmation-width" #addBankModal let-modal>
  <div class="modal-header">
    <div class="header">
      <h5 class="text-uppercase">{{ 'Add Bank' | translate }}</h5>
    </div>
    <button type="button" class="close" (click)="closeAddBank()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="achProcessorName === achAltCode.PAYA">
      <app-paya-ach [selectedMode]="{id:3}" [selectedPayaOption]="selectedPayaOption"
        [payaResponseValidation$]="payaResponseValidation$" [payaRest$]="payaRest$"
        [ppdOrCcdOptionsArray]="ppdOrCcdOptionsArray" [payaTransaction$]="payaTransactionPasser" [isAddBank]="true"
        [parentCloudposForm]="cloudPOSForms" (getExstingCustomerPayload)="getExstingCustomerPayload($event)"
        [consumerId]="consumerId" [selectedTpn]="collectionAccountTpn" (addBankConfirmation)="addBank($event)"
        [defautTerminalType]="defautTerminalType" [ppdOrCcdOptions]="ppdOrCcdOptions" [isFortellisEnabled]="'0'"
        (terminalTypeSelection)="ppdOrCcdSelection($event)" (isPayaCheck)="isPayaChecker($event)"></app-paya-ach>
  </div>

  <div class="modal-footer text-right" *ngIf="achProcessorName === achAltCode.PAYA">
    <button type="button" class="text-right btn btn-danger mr-2" (click)=" onRestFormPaya()" >{{ 'Reset' | translate }}</button>
    <button type="submit" class="text-right btn btn-primary" (click)="payaTransaction()"><span *ngIf = "loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> {{ 'Add' | translate }} </button>
  </div>

  <div class="modal-body" *ngIf="achProcessorName === achAltCode.VERICHECK">
      <app-vericheck-ach [selectedMode]="{id:3}" [selectedPayaOption]="selectedPayaOption" [vericheckTransaction$]="vericheckTransaction$" [vericheckAddAchTransaction$]="vericheckAddAchTransaction$" [vericheckReset$]="vericheckReset$" [parentCloudposForm]="cloudPOSForms" [selectedTpn]="collectionAccountTpn" [isAddAchVericheck]="true" [isAddBank]="true" [consumerId]="consumerId" [isMerchantBillingContext]="true" [achAlternateCardsCount]="alternateCardDetailsLength" [isfromRunASale]="isfromRunASale" [hideMaskedAchClear]="isDisableReset()" [buildVericheckHsmTokenUrl]="buildVericheckGetHsmTokenUrl.bind(this)" (vericheckFormData)="handleVericheckFormData($event)" (getExstingCustomerPayload)="getExstingCustomerPayload($event)" (getConsumerDetail)="getConsumersToken($event)" (clearUnMaskedAlternateCard)="clearUnMaskedAlternateCardData()" (addBankCompleted)="onVericheckAddBankCompleted()" [isFortellisEnabled]="'0'"></app-vericheck-ach>
  </div>

  <div class="modal-footer text-right" *ngIf="achProcessorName === achAltCode.VERICHECK">
    <button type="button" class="text-right btn btn-danger mr-2" (click)="resetActiveAddBankForm()">{{ 'Reset' | translate }}</button>
    <button type="submit" class="text-right btn btn-primary" (click)="submitActiveAddBank()" [disabled]="loading"><span *ngIf = "loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> {{ 'Add' | translate }} </button>
    <!-- <span *ngIf="ppdOrCcdValidationLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span> -->
  </div>
</ng-template>

<ng-container *ngIf="loader">
  <app-loading> </app-loading>
</ng-container>
